import React from 'react'
import Select from 'react-select'
import moment from 'moment'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'

export default class SelectDate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // testVal: '',
      // // month: 33,
      // // year: 333,
      // week: this.getWeekValue() !== null ? this.getWeekValue().value : ''
    }
  }


  getYearOptions() {
    // let options = []
    const fromYear = 2558
    const toYear = new Date().getFullYear() * 1 + 543
    return Array.from(
      { length: toYear - fromYear + 1 },
      (v, k) => ({
        label: fromYear + k,
        value: fromYear + k
      })
    )
  }

  getMonthText(month) {
    let result = ''
    this.getMonthOptions().map((item, index) => {
      if (item.value === month) {
        result = item.label
      }
      return item
    })
    return result
  }

  getWeekDay(year, month, day) {
    let myDate = new Date();
    myDate.setFullYear(year - 543);
    myDate.setMonth((month * 1) - 1);
    myDate.setDate(day);
    return myDate.getDay()
  }

  getMonthOptions() {
    const months = [
      { label: 'ทั้งปี', value: '00' },
      { label: 'มกราคม', value: '01' },
      { label: 'กุมภาพันธ์', value: '02' },
      { label: 'มีนาคม', value: '03' },
      { label: 'เมษายน', value: '04' },
      { label: 'พฤษภาคม', value: '05' },
      { label: 'มิถุนายน', value: '06' },
      { label: 'กรกฎาคม', value: '07' },
      { label: 'สิงหาคม', value: '08' },
      { label: 'กันยายน', value: '09' },
      { label: 'ตุลาคม', value: '10' },
      { label: 'พฤศจิกายน', value: '11' },
      { label: 'ธันวาคม', value: '12' },
    ]
    if (this.props.wholeYear)
      return months
    return months.filter((month) => month.value !== '00')
  }

  getWeekDayOnMonth(year, month) {
    let monthText = this.getMonthText(month)
    let options = []

    let wkDay1 = this.getWeekDay(year, month * 1 - 1, 28);
    let wkDay2 = this.getWeekDay(year, month, 13);
    let wkDay3 = this.getWeekDay(year, month, 28);

    if (wkDay1 === 0 && wkDay2 === 0 && wkDay3 === 0) {
      options = [this.getRangeOption(year, month, 30, 14, monthText, 'firsthalf'), this.getRangeOption(year, month, 15, 29, monthText, 'secondhalf')]
    } else if (wkDay1 === 0 && wkDay2 === 0) {
      options = [this.getRangeOption(year, month, 30, 14, monthText, 'firsthalf'), this.getRangeOption(year, month, 15, 28, monthText, 'secondhalf')]
    } else if (wkDay1 === 0 && wkDay3 === 0) {
      options = [this.getRangeOption(year, month, 30, 13, monthText, 'firsthalf'), this.getRangeOption(year, month, 14, 29, monthText, 'secondhalf')]
    } else if (wkDay2 === 0 && wkDay3 === 0) {
      options = [this.getRangeOption(year, month, 29, 14, monthText, 'firsthalf'), this.getRangeOption(year, month, 15, 29, monthText, 'secondhalf')]
    } else {
      options = [this.getRangeOption(year, month, 29, 13, monthText, 'firsthalf'), this.getRangeOption(year, month, 14, 28, monthText, 'secondhalf')]
    }
    //console.log('getDay', wkDay1, wkDay2, wkDay3, year, month)
    //if(myDate.getDay() == 6 || myDate.getDay() == 0) alert('Weekend!');
    return options;
  }

  getRangeOption(year, month, start, end, monthText, seqInMonth) {
    let between = start + '-' + end
    let startDate = (year - 543) + '/' + ((start > 20) ? (month * 1 - 1) : month) + '/' + start
    let endDate = (year - 543) + '/' + month + '/' + end

    let countOfDays = moment(endDate, "YYYY/MM/DD").diff(moment(startDate, "YYYY/MM/DD"), 'days') + 1
    return { label: start + ' - ' + end + ' ' + monthText, value: between, startDate: startDate, endDate: endDate, countOfWork: countOfDays, seqInMonth: seqInMonth }
  }

  getCurrentRange(options, date) {
    let compareDate = moment(date)
    //let compareDate = moment('2017/05/29','YYYY/MM/DD')
    let option = null
    options.map((item, index) => {
      let startDate = moment(item.startDate, "YYYY/MM/DD")
      let endDate = moment(item.endDate, "YYYY/MM/DD")
      //console.log('compare',compareDate,startDate,endDate)    
      //console.log('item',item,compareDate.toString(),startDate.toString(),endDate.toString())
      if (compareDate.isSameOrAfter(startDate) && compareDate.isSameOrBefore(endDate)) {
        //console.log('Yes')
        option = item
      }
      return item
    })

    if (option === null) {
      option = options[0]
    }

    return option
  }

  getWeekValue() {
    var dt = new Date();
    let month = dt.getMonth() + 1
    month = ('0000' + month).slice(-2)
    let year = (dt.getFullYear() * 1 + 543)
    let options = this.getWeekDayOnMonth(year, month)
    return this.getCurrentRange(options, dt);
  }

  getDayValue() {
    // var dt = new Date();
    // let month = dt.getMonth() + 1
    // month = ('0000' + month).slice(-2)
    // let year = (dt.getFullYear() * 1 + 543)
    // let options = this.getWeekDayOnMonth(year, month)
    // return this.getCurrentRange(options, dt);

    var date = new Date();
    var day = date.getDate();

    return day
  }

  getWeekOptions() {
    var dt = new Date();
    let month = dt.getMonth() + 1
    month = ('0000' + month).slice(-2)
    let year = (dt.getFullYear() * 1 + 543)
    return this.getWeekDayOnMonth(year, month)
  }

  // getDayOptions() {
  //   var dt = new Date();
  //   let month = dt.getMonth() + 1
  //   month = ('0000' + month).slice(-2)
  //   let year = (dt.getFullYear() * 1 + 543)
  //   return this.getWeekDayOnMonth(year, month)
  // }

  getDayOptions() {
    let options = [{value: '00', label: 'ทั้งเดือน'}]
    var lastDay = new Date(this.props.year, this.props.month , 0).getDate();
    for (var i=1;i<=lastDay;i++) {
      options.push({
        value: i,
        label: i
      });
    }
    return options
  }

  onWeekChange(val) {
    this.props.onWeekChange(val)
  }

  onDayChange(val) {
    this.props.onDayChange(val)
  }

  renderWeek() {
    if (this.props.week !== null)
      return (
        <FormGroup style={{ verticalAlign:'top', width: (this.props.renderWCalendar!=undefined&&this.props.weekWCalendar?'200px':'180px'), height: (this.props.renderWCalendar!=undefined&&this.props.weekWCalendar?'36px':'auto'), display: (this.props.renderWCalendar!=undefined&&this.props.weekWCalendar?'inline-flex':'inline-block') }}>
          <Select
            className={this.props.weekWCalendar?'w-calendar':''}
            name="week"
            clearable={false}
            value={this.props.week !== '' ? this.props.week : this.getWeekValue()}
            options={this.getWeekOptions()}
            onChange={this.props.onWeekChange}
          />
          {this.props.renderWCalendar!=undefined&&this.props.weekWCalendar
          ?this.props.renderWCalendar()
          :''
          }
        </FormGroup>
      )
    return ''
  }

  renderDay() {
    if (this.props.day !== null)
      return (
        <FormGroup style={{ verticalAlign:'top', width: (this.props.renderWCalendar!=undefined&&this.props.dayWCalendar?'180px':'90px'), height: (this.props.renderWCalendar!=undefined&&this.props.dayWCalendar?'36px':'auto'), display: (this.props.renderWCalendar!=undefined&&this.props.dayWCalendar?'inline-flex':'inline-block') }}>
          <Select
            className={this.props.dayWCalendar?'w-calendar':''}
            name="week"
            clearable={false}
            value={this.props.day !== '' ? this.props.day : this.getDayValue()}
            options={this.getDayOptions()}
            onChange={this.props.onDayChange}
          />
          {this.props.renderWCalendar!=undefined&&this.props.dayWCalendar
          ?this.props.renderWCalendar()
          :''
          }
        </FormGroup>
      )
    return ''
  }

  renderMonth() {
    const monthNumber = new Date().getMonth() + 1
    const month = ('0000' + monthNumber).slice(-2)
    if (this.props.month !== null)
      return (
        <FormGroup style={{ verticalAlign:'top', width: (this.props.renderWCalendar!=undefined&&this.props.monthWCalendar?'220px':'110px'), height: (this.props.renderWCalendar!=undefined&&this.props.monthWCalendar?'36px':'auto'), display: (this.props.renderWCalendar!=undefined&&this.props.monthWCalendar?'inline-flex':'inline-block') }}>
          <Select
            className={this.props.monthWCalendar?'w-calendar':''}
            name="month"
            clearable={false}
            value={this.props.month !== '' ? this.props.month : month}
            options={this.getMonthOptions()}
            onChange={this.props.onMonthChange}
          />
          {this.props.renderWCalendar!=undefined&&this.props.monthWCalendar
          ?this.props.renderWCalendar()
          :''
          }
        </FormGroup>
      )
    return ''
  }

  renderYear() {
    const year = (new Date().getFullYear() * 1 + 543)
    if (this.props.year !== null)
      return (
        <FormGroup style={{ verticalAlign:'top', width: (this.props.renderWCalendar!=undefined&&this.props.yearWCalendar?'160px':'80px'), height: (this.props.renderWCalendar!=undefined&&this.props.yearWCalendar?'36px':'auto'), display: (this.props.renderWCalendar!=undefined&&this.props.yearWCalendar?'inline-flex':'inline-block') }}>
          <Select
            className={this.props.yearWCalendar?'w-calendar':''}
            name="year"
            clearable={false}
            value={this.props.year !== '' ? this.props.year : year}
            options={this.getYearOptions()}
            onChange={this.props.onYearChange}
          />
          {this.props.renderWCalendar!=undefined&&this.props.yearWCalendar
          ?this.props.renderWCalendar()
          :''
          }
        </FormGroup>
      )
    return ''
  }

  render() {
    return (
      <div style={{ display: this.props.display }}>
        {this.renderYear()}
        {' '}
        {this.renderMonth()}
        {' '}
        {this.renderDay()}
        {' '}
        {this.renderWeek()}
      </div>
    )
  }
}

SelectDate.defaultProps = {
  display: 'inline-block',
  day :null,
  week: null,
  year: null,
  month: null,
  wholeYear: false,
  yearWCalendar: false,
  monthWCalendar: false,
  dayWCalendar: false,
  weekWCalendar: false
}


// WEBPACK FOOTER //
// ./src/component/element/SelectDate.js